export interface HrLearningDashboard {
  owningCompanyId?: number;
  skills?: number;
  employeeSkills?: number;
  courses?: number;
  openAssignments?: number;
  completions?: number;
  expiringOrExpiredItems?: number;
  assignments?: HrLearningAssignment[];
  readinessImpacts?: HrReadinessLearningImpact[];
}

export interface HrSkill {
  skillId?: number;
  owningCompanyId?: number;
  skillCode?: string;
  skillName?: string;
  skillCategory?: string;
  description?: string;
  active?: boolean;
  requiredForReadiness?: boolean;
}

export interface HrEmployeeSkill {
  employeeSkillId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  laborProfileId?: number;
  employeeName?: string;
  employeeNumber?: string;
  skillId?: number;
  proficiencyLevelId?: number;
  skillName?: string;
  skillCode?: string;
  proficiencyLevel?: string;
  skillStatus?: string;
  acquiredDate?: string;
  expiryDate?: string;
  sourceType?: string;
  evidenceDocumentId?: number;
  notes?: string;
}

export interface HrLearningCourse {
  courseId?: number;
  owningCompanyId?: number;
  courseCode?: string;
  courseName?: string;
  courseCategory?: string;
  deliveryMode?: string;
  providerName?: string;
  validityMonths?: number;
  requiredForReadiness?: boolean;
  active?: boolean;
  description?: string;
}

export interface HrLearningAssignment {
  assignmentId?: number;
  owningCompanyId?: number;
  courseId?: number;
  courseName?: string;
  courseCode?: string;
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  assignmentStatus?: string;
  assignedByCustomerId?: number;
  assignedAt?: string;
  dueDate?: string;
  completedAt?: string;
  notes?: string;
}

export interface HrCourseCompletion {
  completionId?: number;
  owningCompanyId?: number;
  assignmentId?: number;
  courseId?: number;
  courseName?: string;
  courseCode?: string;
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  completionStatus?: string;
  completionDate?: string;
  expiryDate?: string;
  score?: number;
  certificateNumber?: string;
  providerReference?: string;
  imported?: boolean;
  notes?: string;
}

export interface HrCertificateRequirement {
  certificateRequirementId?: number;
  owningCompanyId?: number;
  requirementCode?: string;
  requirementName?: string;
  workerCategory?: string;
  jobId?: number;
  skillId?: number;
  skillName?: string;
  courseId?: number;
  courseName?: string;
  certificateType?: string;
  requiredForReadiness?: boolean;
  renewalWindowDays?: number;
  active?: boolean;
  notes?: string;
}

export interface HrLearningCompletionImportRequest {
  owningCompanyId?: number;
  completions?: HrCourseCompletion[];
}

export interface HrLearningCompletionImportResult {
  owningCompanyId?: number;
  received?: number;
  imported?: number;
  warnings?: string[];
  completions?: HrCourseCompletion[];
}

export interface HrReadinessLearningImpact {
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  impactType?: string;
  requirementCode?: string;
  requirementName?: string;
  status?: string;
  expiryDate?: string;
  readinessImpact?: string;
}

export const HR_LEARNING_ASSIGNMENT_STATUSES = ['ASSIGNED', 'IN_PROGRESS', 'OVERDUE', 'COMPLETED', 'CANCELLED'];

export const HR_LEARNING_COMPLETION_STATUSES = ['COMPLETED', 'FAILED', 'WAIVED'];

export const HR_SKILL_STATUSES = ['ACTIVE', 'EXPIRED', 'SUSPENDED', 'WAIVED'];
